import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DateTimeResetIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M13.5 22.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75c4.963 0 9-4.037 9-9s-4.037-9-9-9c-3.318 0-6.247 1.836-7.807 4.547-.576 1.001-.965 2.122-1.118 3.314L6.22 9.217c.14-.142.33-.222.53-.222s.39.08.53.222c.142.141.22.33.22.53s-.078.389-.22.53l-2.986 2.986c-.127.145-.331.237-.544.237-.213 0-.417-.092-.56-.253l-2.97-2.97c-.141-.14-.22-.331-.22-.53 0-.2.078-.389.22-.53.141-.142.33-.22.53-.22s.389.078.53.22l1.771 1.771C3.566 5.683 8.085 1.5 13.5 1.5 19.29 1.5 24 6.21 24 12s-4.71 10.5-10.5 10.5z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
DateTimeResetIcon = __decorateClass([
  customElement("elm-date-time-reset-icon")
], DateTimeResetIcon);
export { DateTimeResetIcon };
